import { Outlet } from "react-router-dom";
import { useState } from "react";
import SellerSidebar from "./SellerSidebar";
import SellerHeader from "./SellerHeader";

const SellerLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden relative">
      <SellerSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
        />
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <SellerHeader setSidebarOpen={setSidebarOpen} />
        <div className="flex-1 overflow-y-auto overflow-x-hidden p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SellerLayout;
